module.exports = __webpack_public_path__ + "static/media/tw.bbb044fc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tw.svg
// module id = 2233
// module chunks = 0